import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { useContext } from "react";
import {
  GetStaffResult,
  getStaff,
  getTaxes,
  GetTaxesResult,
  updateFeatureFlag,
  UpdateFeatureFlagPayload,
  uncached_getFeatureFlag,
  GetFeatureFlagResult,
} from "./clientApi";
import { AppContext } from "../context/app";

export function useStaffQuery(options?: UseQueryOptions<GetStaffResult>) {
  const app = useContext(AppContext);
  return useQuery<GetStaffResult>({
    ...options,
    queryKey: ["staff"],
    queryFn: () => getStaff(app.client!.uuid),
  });
}

export function useTaxesQuery(options?: UseQueryOptions<GetTaxesResult>) {
  const app = useContext(AppContext);
  return useQuery<GetTaxesResult>({
    ...options,
    queryKey: ["taxes"],
    queryFn: () => getTaxes(app.client!.uuid),
  });
}

export function uncached_getNewDashboardFeatureFlagQuery(
  options?: UseQueryOptions<GetFeatureFlagResult>,
) {
  const app = useContext(AppContext);
  return useQuery<GetFeatureFlagResult>({
    ...options,
    queryKey: ["featureFlag", "dashboard_2024_ux_feature_flag"],
    queryFn: () =>
      uncached_getFeatureFlag(
        app.client!.uuid,
        "dashboard_2024_ux_feature_flag",
      ),
  });
}

export function useUpdateFeatureFlagMutation(
  options?: UseMutationOptions<void, unknown, UpdateFeatureFlagPayload>,
) {
  const app = useContext(AppContext);
  return useMutation({
    ...options,
    mutationFn: async (payload: UpdateFeatureFlagPayload) => {
      await updateFeatureFlag(app.client!.uuid, payload.name, payload.value);
    },
  });
}
